import React, { useEffect } from 'react';
import { Row, Col, Select, Tooltip } from 'antd';
import styled from 'styled-components';

import WorkOrderStore from 'stores/WorkOrderStore';
import { Container, StyledSelect } from './common';

const { Option } = Select;

function VMRSSysCode(props) {
  const { title, sys, changeItemProperty, itemKey, vmrs_sys_code } = props;

  const [codes, setCodes] = React.useState([]);
  const [filteredCodes, setFilteredCodes] = React.useState([]);

  useEffect(() => {
    async function fetchVMRSSysCodes() {
      const data = await WorkOrderStore.getVMRSSysCodes();
      setCodes(data);
      setFilteredCodes(data);
    }
    fetchVMRSSysCodes();
  }, []);

  const options = filteredCodes.map((item) => {
    return (
      <Option key={item.sys} value={item.sys}>
        {String(item.sys).padStart(3, '0')}{' '}
        <span className="certain-search-item-count">{item.description}</span>
      </Option>
    );
  });

  const searchHandler = (value) => {
    const filtered = codes.filter((item) =>
      (
        String(item.sys).padStart(3, '0') +
        ' ' +
        item.description?.toLowerCase()
      ).includes(value.toLowerCase())
    );

    setFilteredCodes(filtered);
  };

  const handleChange = (value) => {
    const code = codes.find((d) => d.sys === value);

    changeItemProperty(itemKey, 'vmrs_sys_code_id', null);
    changeItemProperty(
      itemKey,
      'vmrs_sys_code',
      String(code.sys).padStart(3, '0')
    );
    changeItemProperty(itemKey, 'vmrs_sys_text', code.description);

    changeItemProperty(itemKey, 'vmrs_asm_code_id', null);
    changeItemProperty(itemKey, 'vmrs_asm_code', null);
    changeItemProperty(itemKey, 'vmrs_asm_text', null);

    changeItemProperty(itemKey, 'vmrs_comp_code_id', null);
    changeItemProperty(itemKey, 'vmrs_comp_code', null);
    changeItemProperty(itemKey, 'vmrs_comp_text', null);

    changeItemProperty(itemKey, 'vmrs_full_code', null);
    changeItemProperty(itemKey, 'vmrs_full_description', null);
  };

  const tooltipText = (value) => {
    const betterOptions = filteredCodes.map((item) => ({
      value: item.sys,
      label: (
        <span>
          {String(item.sys).padStart(3, '0')}{' '}
          <span className="certain-search-item-count">{item.description}</span>
        </span>
      ),
    }));

    if (value == null) {
      return 'No description available';
    }

    const selectedOption = betterOptions.find(
      (opt) => Number(opt.value) === Number(value)
    );
    return selectedOption ? selectedOption.label : 'No description available';
  };

  return (
    <Container id="container">
      <Row style={{ marginBottom: '5px' }}>
        <Col>{title}</Col>
      </Row>
      <Row>
        <Col span={24}>
          <Tooltip title={tooltipText(vmrs_sys_code)}>
            <StyledSelect
              showSearch
              onSearch={searchHandler}
              value={vmrs_sys_code == null ? '' : Number(vmrs_sys_code)}
              style={{ width: '100%' }}
              onChange={handleChange}
              filterOption={false}
              data-testid="vmrs-system-code-select"
            >
              {options}
            </StyledSelect>
          </Tooltip>
        </Col>
      </Row>
    </Container>
  );
}

export default VMRSSysCode;
